module.exports = __webpack_public_path__ + "static/img/Cameron-McInnes.267be1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cameron-McInnes.jpg
// module id = PDCo
// module chunks = 0